<template>
</template>

<script>
  export default {
    name: 'Home',
    data() {
      return {}
    },
    methods: {
    },
    created() {
      this.$router.push("/login")
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue